// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewFeedComments {
  padding: 8px;
}
.NewFeedComments .ChildFeedComments {
  margin-left: 55px;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column {
  background-color: #fff;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column .NewFeedActions {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column .NewFeedActions [class^=icon-],
[class*=" icon-"] {
  font-size: 1.1rem;
  color: #6d6d6d;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column .NewFeedActions [class^=icon-] + .ms-1,
#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column .NewFeedActions [class*=" icon-"] + .ms-1 {
  font-size: 1rem;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column .NewFeedHeader time {
  font-size: 0.9rem;
}

#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .avatar img {
  border-radius: 100px;
  border: 1px solid #e1e1e1;
}

@media (min-width: 1200px) {
  #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .bg-dark.col-xl-9 {
    width: 66.66666667%;
  }
  #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .bg-dark.col-xl-9 + .col-xl-3 {
    width: 33.33333333%;
  }
}
@media (max-width: 440px) {
  .NewFeedActions {
    height: 65px;
  }
  .NewFeedActions .NewFeedActionButton {
    display: inline-block;
    text-align: center;
    margin-top: 15px;
  }
  .NewFeedActions .NewFeedActionButton span {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewsFeed/Components/NewFeedComments.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,sBAAA;AAAF;;AAEA;EAME,6BAAA;EACA,gCAAA;AAJF;;AAMA;;EAQE,iBAAA;EACA,cAAA;AATF;;AAWA;;EAgBE,eAAA;AAtBF;;AAwBA;EAOE,iBAAA;AA3BF;;AAiCA;EACE,oBAAA;EACA,yBAAA;AA9BF;;AAyCA;EACE;IACE,mBAAA;EAtCF;EAwCA;IAME,mBAAA;EA3CF;AACF;AA8CA;EACE;IACE,YAAA;EA5CF;EA8CA;IACE,qBAAA;IACA,kBAAA;IACA,gBAAA;EA5CF;EA8CA;IACE,cAAA;EA5CF;AACF","sourcesContent":[".NewFeedComments {\n  padding: 8px;\n\n  .ChildFeedComments {\n    margin-left: 55px;\n  }\n}\n\n#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .h-100.flex-column {\n  background-color: #fff;\n}\n#nr-ext-rsicon\n  + .modal-backdrop\n  + .modal\n  .modal-dialog\n  .h-100.flex-column\n  .NewFeedActions {\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n}\n#nr-ext-rsicon\n  + .modal-backdrop\n  + .modal\n  .modal-dialog\n  .h-100.flex-column\n  .NewFeedActions\n  [class^=\"icon-\"],\n[class*=\" icon-\"] {\n  font-size: 1.1rem;\n  color: #6d6d6d;\n}\n#nr-ext-rsicon\n  + .modal-backdrop\n  + .modal\n  .modal-dialog\n  .h-100.flex-column\n  .NewFeedActions\n  [class^=\"icon-\"]\n  + .ms-1,\n#nr-ext-rsicon\n  + .modal-backdrop\n  + .modal\n  .modal-dialog\n  .h-100.flex-column\n  .NewFeedActions\n  [class*=\" icon-\"]\n  + .ms-1 {\n  font-size: 1rem;\n}\n#nr-ext-rsicon\n  + .modal-backdrop\n  + .modal\n  .modal-dialog\n  .h-100.flex-column\n  .NewFeedHeader\n  time {\n  font-size: 0.9rem;\n}\n// #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .position-absolute {\n//   top: 10px;\n//   // left: 10px;\n// }\n#nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .avatar img {\n  border-radius: 100px;\n  border: 1px solid #e1e1e1;\n}\n// #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .cmnt-box .avatar img {\n//   width: 35px;\n//   height: 35px;\n// }\n// #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .cmnt-box textarea {\n//   height: 100px !important;\n//   padding: 15px 10px 10px 55px;\n// }\n\n@media (min-width: 1200px) {\n  #nr-ext-rsicon + .modal-backdrop + .modal .modal-dialog .bg-dark.col-xl-9 {\n    width: 66.66666667%;\n  }\n  #nr-ext-rsicon\n    + .modal-backdrop\n    + .modal\n    .modal-dialog\n    .bg-dark.col-xl-9\n    + .col-xl-3 {\n    width: 33.33333333%;\n  }\n}\n\n@media (max-width: 440px) {\n  .NewFeedActions {\n    height: 65px;\n  }\n  .NewFeedActions .NewFeedActionButton {\n    display: inline-block;\n    text-align: center;\n    margin-top: 15px;\n  }\n  .NewFeedActions .NewFeedActionButton span {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
